import './firebase'
import Vue from 'vue'
import App from './App'
import router from './router'
import { rtdbPlugin as VueFire } from 'vuefire'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import "@mdi/font/css/materialdesignicons.css";
import { VueMasonryPlugin } from "vue-masonry";
import VueMasonry from 'vue-masonry-css'

Vue.use(VueFormWizard)

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuetify)
Vue.use(VueMasonryPlugin);
Vue.use(VueMasonry);


new Vue({
	el: '#app',
	router,
	store: store,
	components: { App },
	template: '<App/>',
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js